// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer__items":"Footer_footer__items__R-vPj","social_media":"Footer_social_media__rao9d"};